import React from 'react'
import PropTypes from 'prop-types'
import {
  PartnerLogosContainer,
  PartnerLogosContainerInner,
  PartnerLogo,
} from './style'

import Logo1 from 'src/assets/img/partnerLogos/easternExposureSeries.png'
import Logo2 from 'src/assets/img/partnerLogos/ESG.png'
import Logo3 from 'src/assets/img/partnerLogos/FHIT.png'
import Logo4 from 'src/assets/img/partnerLogos/MAP.png'
import Logo5 from 'src/assets/img/partnerLogos/MEGA.png'
import Logo6 from 'src/assets/img/partnerLogos/HockeyTv.jpg'
import Logo7 from 'src/assets/img/partnerLogos/ColoradoRampage.jpg'
import Logo8 from 'src/assets/img/partnerLogos/ehl.png'
import Logo9 from 'src/assets/img/partnerLogos/NashvilleJrPredators.png'
import Logo10 from 'src/assets/img/partnerLogos/TotalPackageHockey.png'
import Logo11 from 'src/assets/img/partnerLogos/TriStateSpartans.png'
import Logo12 from 'src/assets/img/partnerLogos/nghl.png'
import Logo13 from 'src/assets/img/partnerLogos/youthWorldHockeyHub.svg'
import Logo14 from 'src/assets/img/partnerLogos/seacoastPerformanceAcademy.png'

const linkEasternExposureSeries = 'https://www.exposureseries.com/'
const linkESG = 'https://endeavoursportsgroup.com'
const linkFHIT = 'https://fhithockey.com'
const linkMAP = 'https://www.maphockey.com'
const linkMEGA = 'https://www.megagoaltending.com'
const linkHockeyTv = 'https://www.hockeytv.com/'
const linkColoradoRampage = 'https://www.corampage.com/'
const linkEHL = 'https://www.easternhockeyleague.org/'
const linkNashvilleJrPredators = 'https://www.jrpredators.com/'
const linkTotalPackageHockey = 'https://totalpackagehockey.com/'
const linkTriStateSpartans = 'https://tristatespartans.com/'
const linkNGHL = 'https://nghlhockey.com/'
const linkYouthWorldHockeyHub = 'https://worldhockeyhub.com/'
const linkSeacoastPerformance = 'https://www.seacoastperformanceacademy.com/'

const PartnerLogos = ({ showPartnerLogos, newPlayerPage }) => {
  const linksArray = [
    linkEasternExposureSeries,
    linkESG,
    linkFHIT,
    linkMAP,
    linkMEGA,
    linkHockeyTv,
    linkColoradoRampage,
    linkEHL,
    linkNashvilleJrPredators,
    linkTotalPackageHockey,
    linkTriStateSpartans,
    linkNGHL,
    linkYouthWorldHockeyHub,
    linkSeacoastPerformance,
  ]
  const logoArray = [
    Logo1,
    Logo2,
    Logo3,
    Logo4,
    Logo5,
    Logo6,
    Logo7,
    Logo8,
    Logo9,
    Logo10,
    Logo11,
    Logo12,
    Logo13,
    Logo14,
  ]

  const rowData = [
    [linksArray[0], logoArray[0]],
    [linksArray[1], logoArray[1]],
    [linksArray[2], logoArray[2]],
    [linksArray[3], logoArray[3]],
    [linksArray[4], logoArray[4]],
    [linksArray[5], logoArray[5]],
    [linksArray[6], logoArray[6]],
    [linksArray[7], logoArray[7]],
    [linksArray[8], logoArray[8]],
    [linksArray[9], logoArray[9]],
    [linksArray[10], logoArray[10]],
    [linksArray[11], logoArray[11]],
    [linksArray[12], logoArray[12]],
    [linksArray[13], logoArray[13]],
  ]

  const LogoRow = rowData.map((item, id) => {
    return newPlayerPage ? (
      <PartnerLogo as={newPlayerPage ? 'div' : 'a'} key={id} newPlayerPage>
        <img alt={`Logo-${id + 1}`} src={item[1]} />
      </PartnerLogo>
    ) : (
      <PartnerLogo
        key={id}
        href={item[0]}
        target="_blank"
        rel="noopener noreferrer">
        <img alt={`Logo-${id + 1}`} src={item[1]} />
      </PartnerLogo>
    )
  })

  return (
    <PartnerLogosContainer
      showPartnerLogos={showPartnerLogos}
      newPlayerPage={newPlayerPage}>
      <PartnerLogosContainerInner>{LogoRow}</PartnerLogosContainerInner>
      <PartnerLogosContainerInner>{LogoRow}</PartnerLogosContainerInner>
    </PartnerLogosContainer>
  )
}

PartnerLogos.propTypes = {
  showPartnerLogos: PropTypes.bool,
  newPlayerPage: PropTypes.bool,
}

export default PartnerLogos
